<template>
	<el-main class="center-wrap orderbox">
		<div class="card-header">
			<div>
				<div class="card-title">图书订单</div>
				<div class="card-desc">查看与管理您的图书订单</div>
			</div>
		</div>
		<div class="orderwrap">
			<div class="ordermain">
				<div class="topbox flexBetween">
					<div class="tabtit">
						<el-link
							v-for="status in mainTradeStatusList"
							:key="status.value"
							:type="activeStatus === status.value ? 'primary' : 'text'"
							:underline="false"
							href="javascript:void(0);"
							@click.native="handleStatus(status.value)"
							>{{ status.label }}</el-link
						>
						<el-dropdown trigger="hover" placement="bottom-start" @command="handleStatus" @visible-change="handleMoreStatusChange">
							<el-link :type="isOtherStatus(activeStatus) ? 'primary' : 'text'" :underline="false" href="javascript:void(0);">更多 <i class="el-icon-arrow-down el-icon--right"></i></el-link>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="status in otherTradeStatusList" :key="status.value" :command="status.value" :class="activeStatus === status.value ? 'is-active' : ''">{{
									status.label
								}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<div class="rightbox">
						<el-input v-model="searchParams.tradeNo" clearable placeholder="输入订单号" size="small" @keyup.enter.native="handleSearch">
							<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
						</el-input>
					</div>
				</div>
				<div v-loading="loading" element-loading-text="加载中...">
					<div v-if="orderList.length > 0">
						<div class="orderbox">
							<table class="order-tbl">
								<colgroup>
									<col class="number-col" />
									<col class="amount-col" />
									<col class="amount-col" />
									<col class="amount-col" />
									<col class="operate-col" />
								</colgroup>
								<thead class="tbl-head tc">
									<th>
										<div class="flexBetween">
											<div>
												<el-date-picker
													v-model="dataVal"
													:picker-options="pickerOptions"
													align="center"
													end-placeholder="结束日期"
													range-separator="至"
													size="small"
													start-placeholder="开始日期"
													type="daterange"
													unlink-panels
													@change="handleDateChange"
												>
												</el-date-picker>
											</div>
											<div style="text-align: center; flex: 1">订单详情</div>
										</div>
									</th>
									<th>商品金额</th>
									<th>订单状态</th>
									<th>发票信息</th>
									<th>订单操作</th>
								</thead>

								<tbody v-for="oinfo in orderList" :id="oinfo.id" :key="oinfo.id" class="tbl-body">
									<tr class="sep-row">
										<td colspan="4"></td>
									</tr>
									<tr class="tr-th">
										<td colspan="5">
											<div class="flexBetween">
												<div>
													<span :title="oinfo.addtime" class="dealtime">{{ oinfo.createTime }}</span>
													<span class="number"
														>订单号：<el-link style="height: 44px; color: #333333" target="neworder" type="text">{{ oinfo.tradeNo }}</el-link></span
													>
													<span class="number" v-if="!isAllDigitalProducts(oinfo) && oinfo.receiveAddress && oinfo.receiveAddress.length > 0"
														>收货人：<el-popover placement="left-start" width="200" trigger="hover" v-if="oinfo.receiveAddress.length > 0">
															<div class="address-box" style="line-height: 24px">
																<div class="flexBetween" style="font-weight: bold">
																	<span>{{ oinfo.receiveAddress[0].receiverName }}</span>
																</div>
																<div class="mobile-box">
																	{{ oinfo.receiveAddress[0].receiverPhone }}
																</div>
																<div class="region-box">
																	{{ oinfo.receiveAddress[0].provinceName }}{{ oinfo.receiveAddress[0].cityName }}{{ oinfo.receiveAddress[0].districtName
																	}}{{ oinfo.receiveAddress[0].detailAddress }}
																</div>
															</div>
															<el-link slot="reference" style="height: 44px; color: #333333" type="text"
																>{{ oinfo.receiveAddress[0].receiverName }}<i class="el-icon-user" style="color: #475569"></i
															></el-link> </el-popover
													></span>
												</div>

												<div>
													<el-link style="height: 44px; margin-right: 30px" type="primary" v-click-once="3000" @click="handleExport(oinfo.tradeNo)">导出订单</el-link>
													<el-link style="height: 44px" type="danger" @click="handleDet(oinfo.tradeNo)">查看详情</el-link>
												</div>
											</div>
										</td>
									</tr>

									<tr v-for="(ginfo, gidx) in oinfo.tradeOrderDetailsGroup" :key="gidx" class="tr-bd">
										<td>
											<div class="flexCenter goods-list" style="justify-content: start; gap: 30px" v-for="info in ginfo.items" :key="info.id">
												<div class="goods-item">
													<div class="g-title">
														<span :class="ginfo.isDigit == 0 ? 'colorblue' : ginfo.isDigit == 1 ? 'colorgreen' : ginfo.isDigit == 2 ? 'colorred' : 'colororange'"
															>【{{ ginfo.isDigit == 0 ? '纸质版' : ginfo.isDigit == 1 ? '电子版' : ginfo.isDigit == 2 ? '结构化版' : '额外添加' }}】</span
														>
														<a :class="{ 'g-item-standard': info.skuId !== null }" @click="toStandardDet(info)">{{ formatProductName(info) }}</a>
													</div>
													<!-- <p class="good-desc card-date sku">{{ info.skuName }}</p> -->
													<div class="g-atcs" v-if="oinfo.tradeStatus > 0 && oinfo.tradeStatus != 4 && oinfo.tradeStatus != 8">
														<!-- 加判断 看是否有在线阅读 -->
														<div v-if="ginfo.isDigit == 0">
															<button class="btn" type="button" @click="handleReadPdf(info.skuId)">
																<span>在线阅读</span>
															</button>
														</div>
														<div v-if="ginfo.isDigit == 1">
															<button class="btn" type="button" @click="handleReadPdf(info.skuId)">
																<span>在线阅读</span>
															</button>

															<button class="btn" type="button" @click="handleDownload(info.standardId, info.skuName)">
																<span>下载PDF</span>
															</button>
														</div>
														<div v-if="ginfo.isDigit == 2">
															<button class="btn" type="button" @click="handleReadJSON(info.skuId)">
																<span>在线阅读</span>
															</button>
														</div>
													</div>
												</div>
												<div class="goods-number">
													<span v-if="info.skuId">{{ info.salePrice }}元 X {{ info.buyNum }}</span>
													<span v-else
														><span class="pending-price">{{ info.salePrice ? info.salePrice + '元' : '待定价' }}</span> X {{ info.buyNum }}</span
													>
												</div>
											</div>
										</td>
										<td v-if="gidx == 0" :rowspan="oinfo.tradeOrderDetailsGroup.length" class="tc">
											<div class="amount">
												<span style="display: inline-block; padding-bottom: 3px">{{ (Number(oinfo.totalAmount) + Number(oinfo.freightAmount)).toFixed(2) }}元</span>
												<br />
												<span v-if="oinfo.freightAmount > 0" class="ftx-13">包含{{ oinfo.freightAmount }}元运费</span>
											</div>
										</td>
										<td v-if="gidx == 0" :rowspan="oinfo.tradeOrderDetailsGroup.length" class="tc">
											<div class="amount">
												<!--												<span>{{ formatterStatus(oinfo.tradeStatus, oinfo.payStatus) }}</span>-->

												<el-tag size="medium" :type="formatterStatusType(oinfo.tradeStatus, oinfo.payStatus)">{{ formatterStatus(oinfo.tradeStatus, oinfo.payStatus) }}</el-tag>

												<div v-if="oinfo.tradeStatus == 2 || (oinfo.tradeStatus == 3 && oinfo.logisticsName)" class="logistics-info">
													<p class="logistics-name">{{ oinfo.logisticsName }}</p>
													<p class="logistics-no-info">
														物流单号
														<i class="el-icon-document-copy icon-copy" style="cursor: pointer" title="点击复制物流单号" @click="copylogisticsNo(oinfo.logisticsNo)"></i>
														{{ oinfo.logisticsNo }}
													</p>
												</div>
												<div v-if="oinfo.payType !== null" class="logistics-info" style="margin-top: 10px">
													<p class="logistics-no">支付方式：{{ formatterPayType(oinfo.payType) }}</p>
													<!-- <el-link v-if="oinfo.payType === 2" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="showPayInfo(oinfo)">查看凭证</el-link> -->
													<el-link v-if="oinfo.payStatus === 3" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="showRemark(oinfo)">查看审核原因</el-link>
												</div>
												<!-- <br /> -->
												<!-- <span class="ftx-13">在线支付</span> -->
											</div>
										</td>
										<td v-if="gidx == 0" :rowspan="oinfo.tradeOrderDetailsGroup.length" class="tc">
											<div v-if="oinfo.tradeStatus > 0 && oinfo.tradeStatus != 4 && oinfo.tradeStatus != 8">
												<span style="display: block">{{ formatterInvoiceStatus(oinfo.invoiceStatus) }}</span>
												<el-link v-if="oinfo.invoiceStatus === 0" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="handleInvoice(oinfo.tradeNo)"
													>查看开票信息</el-link
												>
												<el-link
													v-if="oinfo.invoiceStatus !== 0 && oinfo.invoiceStatus !== 1"
													style="margin-bottom: 4px; padding-right: 0; font-size: 12px"
													type="primary"
													@click="handleApplyInvoice(oinfo.tradeNo)"
													>申请开票</el-link
												>
												<el-link
													v-if="oinfo.invoiceStatus === 1 && oinfo.invoiceInfo"
													style="margin-bottom: 4px; padding-right: 0; font-size: 12px"
													type="primary"
													@click="handleDownloadInvoice(oinfo, oinfo.invoiceInfo)"
													>下载发票(PDF)</el-link
												>
												<el-link
													v-if="oinfo.invoiceStatus === 1 && oinfo.invoiceXml"
													style="margin-bottom: 4px; padding-right: 0; font-size: 12px"
													type="primary"
													@click="handleDownloadInvoice(oinfo, oinfo.invoiceXml)"
													>下载发票(XML)</el-link
												>
												<el-link
													v-if="oinfo.invoiceStatus === 1 && oinfo.invoiceOfd"
													style="margin-bottom: 4px; padding-right: 0; font-size: 12px"
													type="primary"
													@click="handleDownloadInvoice(oinfo, oinfo.invoiceOfd)"
													>下载发票(OFD)</el-link
												>
												<div v-if="oinfo.invoiceStatus === 1" class="logistics-info">
													<p class="logistics-no">更换发票请与客服联系</p>
												</div>
											</div>
										</td>
										<td class="tc" v-if="oinfo.tradeStatus == 1 || oinfo.tradeStatus == 5 || oinfo.tradeStatus == 6">
											<!-- 状态1：已支付 - 按组显示，非纸质商品可退款 -->
											<div class="logistics-info" v-if="oinfo.tradeStatus == 1">
												<el-link v-if="ginfo.isDigit === 0" style="margin-bottom: 4px" type="primary" @click="handleRefund(oinfo.tradeNo)">申请退款</el-link>
												<p v-if="ginfo.isDigit === 1">电子图书为特殊商品，付款后不支持退换货。若有质量问题，请联系客服</p>
											</div>

											<div class="logistics-info" v-if="oinfo.tradeStatus == 5">
												<span v-if="ginfo.isDigit === 0" style="margin-bottom: 4px">退款中</span>
												<p v-if="ginfo.isDigit === 1">电子图书为特殊商品，付款后不支持退换货。若有质量问题，请联系客服</p>
											</div>

											<div class="logistics-info" v-if="oinfo.tradeStatus == 6">
												<span v-if="ginfo.isDigit === 0" style="margin-bottom: 4px">已退款</span>
												<p v-if="ginfo.isDigit === 1">电子图书为特殊商品，付款后不支持退换货。若有质量问题，请联系客服</p>
											</div>

											<div class="logistics-info" v-if="oinfo.tradeStatus == 8">
												<!--												<span v-if="ginfo.isDigit === 0" style="margin-bottom: 4px">已退款</span>-->
												<!-- <p v-if="ginfo.isDigit == 1">{{ ginfo.isDigit == 1 ? '电子图书' : '智能图书' }}为特殊商品，付款后不支持退换货。若有质量问题，请联系客服</p> -->
											</div>

											<!--											<div v-if="ginfo.isDigit == 1 && oinfo.tradeStatus != 8">-->
											<!--												<button v-if="hasRefundableProducts(oinfo)" class="btn" type="button" @click="handleDownloadBatch(oinfo.tradeNo, oinfo.waterMark)">-->
											<!--													<span>批量下载PDF</span>-->
											<!--												</button>-->
											<!--											</div>-->
										</td>

										<td class="tc" v-if="oinfo.tradeStatus != 1 && oinfo.tradeStatus != 5 && oinfo.tradeStatus != 6 && gidx == 0" :rowspan="oinfo.tradeOrderDetails.length">
											<!-- 状态0：待支付 - 合并行，只在第一组显示 -->
											<div v-if="oinfo.tradeStatus == 0 && gidx == 0">
												<!-- {{ oinfo.payStatus }} -->
												<el-link v-if="oinfo.payStatus != 1" style="margin-bottom: 4px" type="primary" @click="showPayModal(oinfo.tradeNo, oinfo.payType)">去付款</el-link>
												<br />
												<el-link v-if="oinfo.payStatus != 1" style="margin-bottom: 4px" type="primary" @click="showPayModalChange(oinfo.tradeNo, oinfo.totalAmount, oinfo.freightAmount)"
													>更换支付方式</el-link
												>
												<br />
												<el-link v-if="oinfo.payStatus != 1" style="margin-bottom: 4px" type="primary" @click="handleCancel(oinfo.tradeNo, oinfo.tradeOrderDetails)">取消订单</el-link>
												<!-- <br /> -->
												<!-- <el-link v-if="oinfo.payStatus != 1" style="margin-bottom: 4px" @click="handleRemove(oinfo.tradeNo)">删除订单</el-link> -->
											</div>

											<!-- 状态2：已发货 - 合并行，只在第一组显示 -->
											<div v-if="oinfo.tradeStatus == 2 && gidx == 0">
												<el-link v-if="!isAllDigitalProducts(oinfo)" style="margin-bottom: 4px" type="primary" @click="handleConfirm(oinfo.tradeNo)">确定收货</el-link>
												<div class="logistics-info">
													<p class="logistics-no">收货之后，如有质量问题，请联系客服</p>
												</div>
												<!--												<button v-if="hasRefundableProducts(oinfo)" class="btn" type="button" @click="handleDownloadBatch(oinfo.tradeNo, oinfo.waterMark)">-->
												<!--													<span>批量下载PDF</span>-->
												<!--												</button>-->
												<!-- <el-link v-if="!isAllDigitalProducts(oinfo)" style="margin-bottom: 4px" type="primary" @click="handleRefund(oinfo.tradeNo)">申请退货退款</el-link> -->
											</div>

											<!-- 状态3：已完成 - 合并行，只在第一组显示 -->
											<div v-if="oinfo.tradeStatus == 3 && gidx == 0">
												<!--												<button v-if="hasRefundableProducts(oinfo)" class="btn" type="button" @click="handleDownloadBatch(oinfo.tradeNo, oinfo.waterMark)">-->
												<!--													<span>批量下载PDF</span>-->
												<!--												</button>-->

												<!-- <el-link style="margin-bottom: 4px" type="primary" @click="handleInvoice(oinfo.tradeNo)">申请开票</el-link> -->
											</div>

											<!-- 状态0：待支付 - 合并行，只在第一组显示 -->
											<div v-if="oinfo.tradeStatus == 8 && gidx == 0">
												<el-link v-if="oinfo.payStatus != 1" style="margin-bottom: 4px" type="primary" @click="handleCancel(oinfo.tradeNo, oinfo.tradeOrderDetails)">取消订单</el-link>
												<!-- <br /> -->
												<!-- <el-link v-if="oinfo.payStatus != 1" style="margin-bottom: 4px" @click="handleRemove(oinfo.tradeNo)">删除订单</el-link> -->
											</div>

											<!-- 状态4/6：已取消/已退款 - 合并行，只在第一组显示 -->
											<div v-if="(oinfo.tradeStatus == 4 || oinfo.tradeStatus == 6 || oinfo.tradeStatus == 8) && gidx == 0">
												<!-- <el-link style="margin-bottom: 4px" @click="handleRemove(oinfo.tradeNo)">删除订单</el-link> -->
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="pagebox" style="margin-top: 16px">
							<el-pagination :page-size="searchParams.pageSize" :total="totalNum" background layout="total, prev, pager, next" @current-change="handlePageChange"> </el-pagination>
						</div>
					</div>
					<div v-if="orderList.length == 0" class="emptybox">
						<el-empty description="没有此状态下的订单"></el-empty>
					</div>
				</div>
			</div>
		</div>
		<DialogShowPayInfo ref="DialogShowPayInfoRef" :corporateInfoUrl="corporateInfoUrl"></DialogShowPayInfo>
		<!-- 评价订单 -->
		<!-- <DialogEvaluate ref="DialogEvaluateRef"></DialogEvaluate> -->
		<Pay ref="PayRef" :tradeComment="tradeComment" :orderNum="orderNum" :total="total" @successPay="successPay"></Pay>
		<!-- 下载pdf电子版 -->
		<DialogWatermark ref="dialogWatermark" @confirmInfo="confirmDownload"></DialogWatermark>
		<!-- 申请退换货 -->
		<DialogOrderRefund ref="dialogOrderRefund" :curTradeNo="curTradeNo" :curGoods="curGoods" @confirmInfo="postConsumerOrderList"></DialogOrderRefund>
		<!-- 发票信息 -->
		<DialogInvoiceInfo ref="dialogInvoiceInfo" :form="invoiceForm"></DialogInvoiceInfo>
		<!-- 申请开票 -->
		<DialogApplyInvoice ref="dialogApplyInvoice" :tradeNo="curOrderNo" @confirm="postConsumerOrderList"></DialogApplyInvoice>
		<!-- 取消订单 -->
		<DialogCancelOrder ref="dialogCancelOrder" @confirm="postConsumerOrderList" :tradeNo="curOrderNo" :tradeOrderDetails="curTradeOrderDetails"></DialogCancelOrder>
		<!-- 更换支付方式 -->
		<DialogChangePayType ref="dialogChangePayType" :noOfflineTransfer="true" @changePayType="changePayType" :tradeNo="curOrderNo"></DialogChangePayType>
	</el-main>
</template>

<script>
	import Y from '@/utils/Y';
	import { postConsumerOrderList, getConsumerOrderInfo, getConsumerOrderInvoice, getConsumerOrderCancel, getConsumerOrderReceipt, getConsumerOrderQueryStandard } from '@/api/order/order.js';
	import DialogEvaluate from './components/DialogEvaluate.vue';
	import Pay from '@/components/Pay/index.vue';
	import moment from 'moment';
	import DialogWatermark from '@/views/StandardsView/components/DialogWatermark.vue';
	import DialogOrderRefund from '@/views/Order/components/DialogOrderRefund.vue';
	import TLoading from '@/utils/TLoading.js';
	import User from '@/utils/User.js';
	import TMessage from '@/utils/TMessage.js';
	import DialogShowPayInfo from '@/views/UserCenter/components/DialogShowPayInfo.vue';
	import DialogInvoiceInfo from '@/views/UserCenter/components/DialogInvoiceInfo.vue';
	import DialogApplyInvoice from '@/views/UserCenter/components/DialogApplyInvoice.vue';
	import DialogCancelOrder from '@/views/UserCenter/components/DialogCancelOrder.vue';
	import DialogChangePayType from '@/views/UserCenter/components/DialogChangePayType.vue';
	import CopyText from '@/utils/CopyText';

	import hiprintNest from '@/utils/hiprintNest.js';
	import orderDataTemplate from '/public/hiprintTemplate/order.js';

	export default {
		data() {
			return {
				curOrderNo: '',
				curTradeOrderDetails: [],
				invoiceForm: {},
				loading: false,
				dataVal: [],
				pickerOptions: {
					shortcuts: [
						{
							text: ''
						},
						{
							text: '最近一周',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit('pick', [start, end]);
							}
						}
					]
				},
				searchParams: {
					tradeNo: '',
					tradeStatus: [],
					payStatus: [],
					queryBegin: '',
					queryEnd: '',
					pageSize: 10,
					pageNum: 1
				},
				tradeStatusList: [
					{ label: '全部订单', value: '' },
					{ label: '待支付', value: 0 },
					{ label: '已支付', value: 1 },
					{ label: '已发货', value: 2 },
					{ label: '已完成', value: 3 },
					{ label: '已取消', value: 4 },
					{ label: '退款中', value: 5 },
					{ label: '已退款', value: 6 },
					{ label: '待审核', value: 8 }
				],

				// 主要订单状态（默认显示）
				mainTradeStatusList: [
					{ label: '全部订单', value: '' },
					{ label: '待支付', value: 0 },
					{ label: '已支付', value: 1 },
					{ label: '已完成', value: 3 }
				],
				// 其他订单状态（通过更多下拉选择）
				otherTradeStatusList: [
					{ label: '已发货', value: 2 },
					{ label: '已取消', value: 4 },
					{ label: '退款中', value: 5 },
					{ label: '已退款', value: 6 },
					{ label: '待审核', value: 8 }
				],
				showMoreStatus: false,
				orderList: [],
				totalNum: 0,
				activeStatus: '',

				orderNum: null,
				total: null,
				tradeComment: null,

				downPdfParams: {
					skuId: '',
					watermark: ''
				},

				curTradeNo: '',
				curGoods: [],

				corporateInfoUrl: '',
				invoiceInfoUrl: '',

				pdfName: ''
			};
		},
		components: {
			DialogEvaluate,
			Pay,
			DialogWatermark,
			DialogOrderRefund,
			DialogShowPayInfo,
			DialogInvoiceInfo,
			DialogApplyInvoice,
			DialogCancelOrder,
			DialogChangePayType
		},
		methods: {
			copylogisticsNo(logisticsNo) {
				// const logisticsInfo = document.querySelector('.logistics-no-info').innerText;
				CopyText.copyMessage(logisticsNo);
				// TMessage.success('复制成功');
			},

			formatProductName(item) {
				if (item.isDigit == 0 && !item.skuId) {
					return item.spuName;
				}
				if (item.spuName && item.standardCode && item.spuName.indexOf(item.standardCode) !== -1) {
					return item.spuName;
				}
				return item.standardCode ? item.standardCode + ' ' + item.spuName : item.spuName;
			},

			toStandardDet(ginfo) {
				if (!ginfo.skuId) return;
				const { standardId, skuName } = ginfo;
				const targetRoute = this.$router.resolve({
					path: '/StandardsDet',
					query: { id: standardId }
				});
				window.open(targetRoute.href, '_blank');
			},

			changePayType(val) {
				const { tradeNo, payType } = val;
				getConsumerOrderInfo(tradeNo).then(res => {
					if (res.code == 200) {
						//查询订单状态
						if (res.data.orderBasic.tradeStatus == 0) {
							if (payType == 0) {
								this.$router.push({ path: '/WeChatPay', query: { orderId: tradeNo } });
							} else if (payType == 1) {
								this.$router.push({ path: '/AlipayPay', query: { orderId: tradeNo } });
							} else if (payType == 2) {
								this.$router.push({ path: '/OfflineTransfer', query: { orderId: tradeNo } });
							}
						} else {
							TMessage.warning('订单已支付或已取消');
						}
					}
				});
			},
			handleApplyInvoice(tradeNo) {
				this.curOrderNo = tradeNo;
				this.$refs.dialogApplyInvoice.dialogVisible = true;
			},
			formatterInvoiceStatus(invoiceStatus) {
				return invoiceStatus === 0 ? '开票中' : invoiceStatus === 1 ? '已开票' : '未开票';
			},
			async handleDownloadInvoice(invoiceInfo, fileInfo) {
				try {
					const response = await fetch(`/webL_api/third/files/info/${fileInfo}`, {
						headers: {
							Authorization: 'Bearer ' + User.getToken(),
							'corporate-id': User.getCorporate().corporateId
						}
					});
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					const arrayBuffer = await response.arrayBuffer();

					// 通过文件头魔数检测真实文件类型（避免Content-Type不准确）
					const detected = this.detectFileType(arrayBuffer);
					const realMime = detected ? detected.mime : response.headers.get('Content-Type') || 'application/octet-stream';
					// const realExt = detected ? detected.ext : '';

					// 优先从Content-Disposition获取文件名
					let fileName = `${invoiceInfo.tradeNo}`;
					// const disposition = response.headers.get('Content-Disposition');
					// if (disposition) {
					// 	const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
					// 	if (match && match[1]) {
					// 		fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
					// 	}
					// }
					// if (!fileName.includes('.')) {
					// 	fileName += '.' + (realExt || 'jpg');
					// }

					const blob = new Blob([arrayBuffer], { type: realMime });

					// 下载文件
					this.downloadFile(blob, fileName, '发票');
				} catch (error) {
					console.error('获取发票失败:', error);
					this.$message.error('发票下载失败');
					return null;
				}
			},

			// 通过文件头魔数检测真实文件类型
			detectFileType(arrayBuffer) {
				const arr = new Uint8Array(arrayBuffer);
				if (arr.length < 4) return null;

				// RAR: 52 61 72 21 1A 07 (Rar!␚␇)
				if (arr.length >= 7 && arr[0] === 0x52 && arr[1] === 0x61 && arr[2] === 0x72 && arr[3] === 0x21 && arr[4] === 0x1a && arr[5] === 0x07) {
					return { ext: 'rar', mime: 'application/vnd.rar' };
				}
				// ZIP 系（zip / xlsx / docx）：50 4B 03 04
				if (arr[0] === 0x50 && arr[1] === 0x4b && arr[2] === 0x03 && arr[3] === 0x04) {
					// 在ZIP二进制中搜索特征路径区分 docx / xlsx / 纯zip
					// docx 内包含 "word/" 路径，xlsx 内包含 "xl/" 路径
					const searchBytes = pattern => {
						const bytes = new TextEncoder().encode(pattern);
						for (let i = 0; i <= arr.length - bytes.length; i++) {
							let match = true;
							for (let j = 0; j < bytes.length; j++) {
								if (arr[i + j] !== bytes[j]) {
									match = false;
									break;
								}
							}
							if (match) return true;
						}
						return false;
					};
					if (searchBytes('word/')) {
						return { ext: 'docx', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' };
					}
					if (searchBytes('xl/')) {
						return { ext: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
					}
					// 非 Office 格式，返回纯 ZIP
					return { ext: 'zip', mime: 'application/zip' };
				}
				// PDF: %PDF
				if (arr[0] === 0x25 && arr[1] === 0x50 && arr[2] === 0x44 && arr[3] === 0x46) {
					return { ext: 'pdf', mime: 'application/pdf' };
				}
				// JPEG: FF D8 FF
				if (arr[0] === 0xff && arr[1] === 0xd8 && arr[2] === 0xff) {
					return { ext: 'jpg', mime: 'image/jpeg' };
				}
				// PNG: 89 50 4E 47
				if (arr[0] === 0x89 && arr[1] === 0x50 && arr[2] === 0x4e && arr[3] === 0x47) {
					return { ext: 'png', mime: 'image/png' };
				}
				// GIF: 47 49 46 38
				if (arr[0] === 0x47 && arr[1] === 0x49 && arr[2] === 0x46 && arr[3] === 0x38) {
					return { ext: 'gif', mime: 'image/gif' };
				}
				// WebP: 52 49 46 46 ... 57 45 42 50
				if (arr[0] === 0x52 && arr[1] === 0x49 && arr[2] === 0x46 && arr[3] === 0x46 && arr.length >= 12 && arr[8] === 0x57 && arr[9] === 0x45 && arr[10] === 0x42 && arr[11] === 0x50) {
					return { ext: 'webp', mime: 'image/webp' };
				}
				// BMP: 42 4D
				if (arr[0] === 0x42 && arr[1] === 0x4d) {
					return { ext: 'bmp', mime: 'image/bmp' };
				}
				// OLE2 系（doc / xls）：D0 CF 11 E0
				if (arr[0] === 0xd0 && arr[1] === 0xcf && arr[2] === 0x11 && arr[3] === 0xe0) {
					return { ext: 'doc', mime: 'application/msword' };
				}
				return null;
			},

			downloadInvoice(invoiceInfoUrl) {
				var image = new Image();
				image.setAttribute('crossOrigin', 'anonymous');
				var _this = this;
				image.onload = function () {
					var canvas = document.createElement('canvas');
					canvas.width = image.width;
					canvas.height = image.height;
					var context = canvas.getContext('2d');
					context.drawImage(image, 0, 0, image.width, image.height);
					var url = canvas.toDataURL('image/png'); //得到图片的base64编码数据
					var a = document.createElement('a'); // 生成一个a元素
					var event = new MouseEvent('click'); // 创建一个单击事件
					a.download = _this.projectName || 'photo'; // 设置图片名称
					a.href = url; // 将生成的URL设置为a.href属性
					a.dispatchEvent(event); // 触发a的单击事件
				};
				image.src = invoiceInfoUrl;
				this.$message.success('发票下载成功');
			},

			// 通用文件下载方法
			downloadFile(blob, filename, type) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url); // 释放内存
				// 显示下载成功提示
				this.$message.success(type + '下载成功！');
				TLoading.close(this.loadingInstance);
			},

			handleInvoice(tradeNo) {
				getConsumerOrderInvoice(tradeNo).then(res => {
					if (res.code === 200) {
						this.$refs.dialogInvoiceInfo.dialogVisible = true;
						this.invoiceForm = res.data;
						// this.corporateInfoUrl = res.data;
						// this.$refs.invoiceDialog.show();
					}
				});
			},

			showRemark(orderBasic) {
				let remark = orderBasic.remark ? '支付凭证信息审核未通过原因：' + orderBasic.remark : '支付凭证信息审核未通过原因：未填写，具体请联系管理员！';
				this.$confirm(remark, '提示', {
					showConfirmButton: false,
					cancelButtonText: '关闭',
					type: 'warning'
				})
					.then(() => {})
					.catch(() => {});
			},

			async showPayInfo(info) {
				try {
					const response = await fetch(`/webL_api/third/files/info/${info.paymentVoucher}`, {
						headers: {
							Authorization: 'Bearer ' + User.getToken()
						}
					});
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					const arrayBuffer = await response.arrayBuffer();
					const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
					const imageUrlData = URL.createObjectURL(blob);
					this.corporateInfoUrl = imageUrlData;
					this.$refs.DialogShowPayInfoRef.dialogVisible = true;
				} catch (error) {
					console.error('获取图片失败:', error);
					return null;
				}
			},

			formatterPayType(payType) {
				if (payType === null) {
					return '';
				} else {
					return payType == 0 ? '微信支付' : payType == 1 ? '支付宝支付' : '对公转账';
				}
			},
			isOtherStatus(status) {
				return this.otherTradeStatusList.some(item => item.value === status);
			},
			handleMoreStatusChange(visible) {
				this.showMoreStatus = visible;
			},
			// 在线阅读
			handleReadPdf(skuId) {
				getConsumerOrderQueryStandard(skuId).then(res => {
					if (res.code == 200) {
						this.info = res.data;
						if (this.info.defaultPdf) {
							const targetRoute = this.$router.resolve({
								path: '/StandardsPdf',
								query: { id: this.info.standardId, code: this.info.standardCode, title: this.info.standardName, fileName: this.info.defaultPdf, docId: this.info.standardId }
							});
							window.open(targetRoute.href, '_blank');
							// this.$router.push({ path: '/index/StandardsPdf', query: { id: this.info.standardId, title: this.info.standardName, fileName: this.info.defaultPdf, docId: this.info.standardId } });
						} else {
							TMessage.warning('未找到文件');
						}
					}
				});
			},

			//结构化阅读
			handleReadJSON(skuId) {
				getConsumerOrderQueryStandard(skuId).then(res => {
					if (res.code == 200) {
						this.info = res.data;
						if (this.info.defaultJson) {
							this.$router.push({ path: '/StandardsDoc', query: { docId: this.info.standardId } });
						} else {
							TMessage.warning('未找到文件');
						}
					}
				});
			},

			//下载文件-批量
			handleDownloadBatch(tradeNo, waterMark) {
				this.pdfName = '电子版文件';
				let params = {
					tradeNo
				};
				this.handleWatermarkConfirm(params);

				return;
				if (waterMark) {
					let params = {
						tradeNo
					};
					this.handleWatermarkConfirm(params);
				} else {
					this.downPdfParams.tradeNo = tradeNo;
					this.$refs.dialogWatermark.dialogVisible = true;
				}
			},

			//下载文件
			handleDownload(standardId, skuName) {
				this.pdfName = skuName;
				this.handleWatermarkConfirm(standardId);
			},

			// 确认下载
			confirmDownload(val) {
				this.downPdfParams.watermark = val.watermark;
				this.downPdfParams.waterType = val.waterType;
				this.handleWatermarkConfirm(this.downPdfParams);
			},

			// 确认下载文件
			async handleWatermarkConfirm(standardId) {
				this.loadingInstance = TLoading.startBgWhite({ text: '文件准备中，请耐心等待 \n 若长时间未启动下载，请刷新页面后重试' });
				try {
					const response = await fetch(`/webL_api/consumer/order/downloadCorporateBook/${standardId}`, {
						method: 'get',
						headers: {
							Authorization: 'Bearer ' + User.getToken(),
							'corporate-id': User.getCorporate().corporateId,
							'Content-Type': 'application/json'
						}
					});

					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					const arrayBuffer = await response.arrayBuffer();
					const blob = new Blob([arrayBuffer], { type: 'zip' });

					this.$refs.dialogWatermark.dialogVisible = false;

					// 创建下载链接而不是打开文件
					this.downloadFile(blob, this.pdfName + '.zip', '文件');

					// this.postConsumerOrderList();
				} catch (error) {
					TLoading.close(this.loadingInstance);
					console.error('下载文件失败:', error);
					this.$message.error('文件下载失败，请重试！');
				}
			},

			// 支付成功后刷新订单列表
			successPay() {
				this.postConsumerOrderList();
			},

			// 判断订单中所有商品是否都是电子版
			isAllDigitalProducts(order) {
				if (!order.tradeOrderDetails || order.tradeOrderDetails.length === 0) {
					return false;
				}
				// 使用every方法检查所有商品是否都是电子版（isDigit === 1）或结构化版（isDigit === 2）
				return order.tradeOrderDetails.every(item => item.isDigit === 1 || item.isDigit === 2);
			},

			// 检查订单中是否包含非纸质商品（可用于退款的商品）
			hasRefundableProducts(order) {
				if (!order.tradeOrderDetails || order.tradeOrderDetails.length === 0) {
					return false;
				}
				// 检查是否有非纸质商品（isDigit !== 0）
				return order.tradeOrderDetails.some(item => item.isDigit !== 0);
			},

			handlePageChange(pageNum) {
				this.searchParams.pageNum = pageNum;
				this.scrollToOrderList();
				this.postConsumerOrderList();
			},

			// 滚动到订单列表顶部
			scrollToOrderList() {
				this.$nextTick(() => {
					const element = document.querySelector('.orderwrap');
					if (element) {
						const elementRect = element.getBoundingClientRect();
						const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
						const targetPosition = elementRect.top + scrollTop - 90;
						window.scrollTo({
							top: targetPosition,
							behavior: 'smooth'
						});
					}
				});
			},

			gotoDetail(orderNo) {
				this.$router.push({ path: '/OrderDetail', query: { orderId: orderNo } });
			},

			handleDateChange(value) {
				if (this.dataVal == null) {
					this.searchParams.queryBegin = '';
					this.searchParams.queryEnd = '';
				} else {
					if (this.dataVal[0]) {
						this.searchParams.queryBegin = moment(this.dataVal[0]).format('YYYY-MM-DD');
					}
					if (this.dataVal[1]) {
						this.searchParams.queryEnd = moment(this.dataVal[1]).format('YYYY-MM-DD');
					}
				}
				this.postConsumerOrderList();
			},

			showPayModal(tradeNo, payType) {
				getConsumerOrderInfo(tradeNo).then(res => {
					if (res.code == 200) {
						//查询订单状态
						if (res.data.orderBasic.tradeStatus == 0) {
							if (payType == 0) {
								this.$router.push({ path: '/WeChatPay', query: { orderId: tradeNo } });
							} else if (payType == 1) {
								this.$router.push({ path: '/AlipayPay', query: { orderId: tradeNo } });
							} else if (payType == 2) {
								this.$router.push({ path: '/OfflineTransfer', query: { orderId: tradeNo } });
							}
						} else {
							TMessage.warning('订单已支付或已取消');
						}
					}
				});

				// this.orderNum = tradeNo;
				// this.total = (totalAmount+freightAmount).toFixed(2);
				// this.$refs.PayRef.payModal = true;
			},

			showPayModalChange(tradeNo, totalAmount, freightAmount) {
				this.curOrderNo = tradeNo;
				this.$refs.dialogChangePayType.dialogVisible = true;
				return;
				getConsumerOrderInfo(tradeNo).then(res => {
					if (res.code == 200) {
						//查询订单状态
						if (res.data.orderBasic.tradeStatus == 0) {
							//修改订单支付方式
							this.orderNum = tradeNo;
							this.total = (totalAmount + freightAmount).toFixed(2);
							this.tradeComment = res.data.orderBasic.tradeComment;
							this.$refs.PayRef.payModal = true;
						} else {
							TMessage.warning('订单已支付或已取消');
						}
					}
				});
			},

			handleSearch() {
				this.searchParams.pageNum = 1;
				this.postConsumerOrderList();
			},

			async postConsumerOrderList() {
				this.loading = true;
				await postConsumerOrderList(this.searchParams)
					.then(res => {
						this.orderList = res.data.rows;
						this.totalNum = res.data.totalNum;
						if (this.totalNum) {
							this.orderList.forEach(item => {
								const grouped = _.groupBy(item.tradeOrderDetails, 'isDigit');
								const digit0Items = grouped[0] || [];
								const digit0WithSku = digit0Items.filter(d => d.skuId);
								const digit0WithoutSku = digit0Items.filter(d => !d.skuId);
								item.tradeOrderDetailsGroup = [
									{ isDigit: 0, items: digit0WithSku },
									{ isDigit: 1, items: grouped[1] || [] },
									{ isDigit: 2, items: grouped[2] || [] },
									{ isDigit: 3, items: digit0WithoutSku }
								].filter(group => group.items.length > 0);
							});
						}
					})
					.catch(err => {
						Y.msg.error(err.message || '获取订单列表失败');
					})
					.finally(() => {
						this.loading = false;
					});
			},

			handleStatus(item) {
				this.activeStatus = item;
				if (this.activeStatus === '') {
					this.searchParams.tradeStatus = [];
				} else {
					this.searchParams.tradeStatus = [this.activeStatus];
				}
				const query = { ...this.$route.query };
				delete query.tradeStatus;
				this.$router.replace({ query }).catch(() => {});

				this.postConsumerOrderList();
			},

			formatterStatusType(tradeStatus, payStatus) {
				let statusType = '';
				switch (tradeStatus) {
					case 0:
						statusType = 'primary';
						if (payStatus === 1) {
							statusType = 'primary';
						}
						if (payStatus === 3) {
							statusType = 'danger';
						}
						break;
					case 1:
						statusType = 'primary';
						break;
					case 2:
						statusType = 'primary';
						break;
					case 3:
						statusType = 'success';
						break;
					case 4:
						statusType = 'info';
						break;
					case 5:
						statusType = 'primary';
						break;
					case 6:
						statusType = 'info';
						break;
					case 8:
						statusType = 'warning';
						break;
					default:
						statusType = '未知状态';
				}
				return statusType;
			},

			formatterStatus(tradeStatus, payStatus) {
				let statusText = '';
				switch (tradeStatus) {
					case 0:
						statusText = '待支付';
						if (payStatus === 1) {
							statusText = '凭证审核中';
						}
						if (payStatus === 3) {
							statusText = '凭证审核不通过';
						}
						break;
					case 1:
						// statusText = '已支付';
						statusText = '待发货';
						break;
					case 2:
						statusText = '已发货';
						break;
					case 3:
						statusText = '已完成';
						break;
					case 4:
						statusText = '已取消';
						break;
					case 5:
						statusText = '退款中';
						break;
					case 6:
						statusText = '已退款';
						break;
					case 8:
						statusText = '待审核';
						break;
					default:
						statusText = '未知状态';
				}
				return statusText;
			},

			//删除订单
			handleRemove(tradeNo) {
				Y.confirm('确认删除此订单吗？').then(rlt => {
					if (rlt.confirm) {
						this.getConsumerOrderCancel(tradeNo);
					}
				});
			},

			//确认收货
			handleConfirm(tradeNo) {
				Y.confirm('请确保您已收到并验收商品，确认后，本单交易完成！').then(rlt => {
					if (rlt.confirm) {
						this.getConsumerOrderReceipt(tradeNo);
					}
				});
			},

			//确认收货
			async getConsumerOrderReceipt(tradeNo) {
				await getConsumerOrderReceipt(tradeNo)
					.then(res => {
						Y.msg.success('订单确认收货成功！');
						this.postConsumerOrderList();
					})
					.catch(err => {
						Y.msg.error(err.message || '订单确认收货失败');
					});
			},

			//取消订单
			handleCancel(tradeNo, tradeOrderDetails) {
				Y.confirm('确认取消此订单吗？').then(rlt => {
					if (rlt.confirm) {
						this.getConsumerOrderCancel(tradeNo);
					}
				});
				// this.curOrderNo = tradeNo;
				// this.curTradeOrderDetails = tradeOrderDetails;
				// this.$refs.dialogCancelOrder.dialogVisible = true;
			},

			//取消订单
			async getConsumerOrderCancel(tradeNo) {
				await getConsumerOrderCancel(tradeNo)
					.then(res => {
						Y.msg.success('订单取消成功！');
						this.postConsumerOrderList();
					})
					.catch(err => {
						Y.msg.error(err.message || '订单取消失败');
					});
			},

			//删除
			// async getConsumerOrderCancel(tradeNo) {
			// 	await getConsumerOrderCancel(tradeNo)
			// 		.then(res => {
			// 			Y.msg.success('订单删除成功！');
			// 			this.postConsumerOrderList();
			// 		})
			// 		.catch(err => {
			// 			Y.msg.error(err.message || '订单删除失败');
			// 		});
			// },

			//查看详情
			handleDet(tradeNo) {
				const targetRoute = this.$router.resolve({
					path: '/OrderDet',
					query: { orderId: tradeNo }
				});
				window.open(targetRoute.href, '_blank');
				// this.goto({ path: '/index/OrderDet', query: { orderId: tradeNo } });
			},

			//导出订单
			handleExport(tradeNo) {
				//先调用获取订单数据的接口，再组织参数
				getConsumerOrderInfo(tradeNo).then(res => {
					if (res.code == 200) {
						const { orderAddress, orderBasic, orderDetails } = res.data;

						let buyNumTotal = 0;
						let beforeAmountTotal = 0;
						let afterAmountTotal = 0;

						orderDetails.forEach((item, index) => {
							buyNumTotal += item.buyNum;
							item.no = index + 1;

							if (item.isDigit == 0 && !item.skuId) {
								item.name = item.spuName;
								item.isDigitStr = '额外添加';
							} else {
								//判断skuName是否包含standardCode，如果包含则不重复拼接
								item.name = item.standardCode && item.skuName.indexOf(item.standardCode) === -1 ? item.standardCode + ' ' + item.skuName : item.skuName;
								item.isDigitStr = item.isDigit == 1 ? '电子版' : '纸质版';
							}

							item.fixedPrice = item.fixedPrice || item.salePrice || null;

							//折扣率
							if (item.fixedPrice && item.salePrice) {
								item.discount = (item.salePrice / item.fixedPrice).toFixed(2);
								item.beforeAmount = (item.buyNum * item.fixedPrice).toFixed(2);
								item.afterAmount = (item.buyNum * item.salePrice).toFixed(2);
							} else {
								item.discount = null;
								item.beforeAmount = null;
								item.afterAmount = null;
							}

							//总码洋（原价）
							beforeAmountTotal += Number(item.buyNum * item.fixedPrice);
							//总实洋（总价）
							afterAmountTotal += Number(item.totalPrice);
						});

						let receiverName,
							receiverPhone,
							receiverAddress = '';
						if (orderAddress != null) {
							let receiveAddressInfo = orderAddress;
							receiverName = receiveAddressInfo.receiverName;
							receiverPhone = receiveAddressInfo.receiverPhone;
							receiverAddress = receiveAddressInfo.provinceName + receiveAddressInfo.cityName + receiveAddressInfo.districtName + receiveAddressInfo.detailAddress;
						}
						let printData = {
							consumerCode: orderBasic.consumerCode,
							tradeNo: orderBasic.tradeNo,
							tradeOrderTypeTotal: orderDetails.length,
							totalAmount: (orderBasic.totalAmount + orderBasic.freightAmount).toFixed(2),
							beforeAmountTotal: beforeAmountTotal.toFixed(2),
							afterAmountTotal: afterAmountTotal.toFixed(2),
							payTypeStr: orderBasic.payType == 0 ? '微信' : orderBasic.payType == 1 ? '支付宝' : '对公转账',
							freightAmount: orderBasic.freightAmount,
							buyNumTotal: buyNumTotal,
							remark: orderBasic.remark,
							receiverName: receiverName,
							receiverPhone: receiverPhone,
							receiverAddress: receiverAddress,
							tradeOrderDetails: orderDetails,
							createBy: orderBasic.createBy,
							createTime: orderBasic.createTime
						};
						hiprintNest(printData, orderDataTemplate, orderBasic.tradeNo);
					}
				});
			},

			//退款
			handleRefund(tradeNo) {
				this.curTradeNo = tradeNo;
				let curGoods = this.orderList.find(item => item.tradeNo === tradeNo).tradeOrderDetails;
				//过滤 item.isDigit == 0 && item.skuId 存在的商品
				this.curGoods = curGoods.filter(item => item.isDigit == 0 && item.skuId);
				this.$refs.dialogOrderRefund.dialogVisible = true;
			},

			handleEvaluate(tradeNo) {
				// this.$refs.DialogEvaluateRef.dialogVisible = true;
				Y.msg.info('跳转到评价页面，待开发...');
			}

			// handleInvoice(tradeNo) {
			// 	Y.msg.info('跳转到开票页面，待开发...');
			// }
		},

		created() {
			if (this.$route.query.orderNum) {
				this.searchParams.tradeNo = this.$route.query.orderNum;
			}
		},

		watch: {
			$route: {
				handler: function (val, oldVal) {
					if (val.query.orderNum) {
						this.searchParams.tradeNo = val.query.orderNum;
					}
					if (val.query.tradeStatus !== null && val.query.tradeStatus !== undefined) {
						this.searchParams.tradeStatus = [val.query.tradeStatus];
						this.activeStatus = Number(val.query.tradeStatus);
					} else {
						this.searchParams.tradeStatus = [];
						this.activeStatus = '';
					}
					this.postConsumerOrderList();
				},
				immediate: true
			}
		}
	};
</script>

<style lang="less" scoped>
	.goods-list:not(:last-child) {
		margin-bottom: 15px;
		.goods-item:not(:last-child) {
			// margin-bottom: 15px;
		}
	}
	.topbox {
		margin-bottom: 10px;
		.tabtit {
			margin: 0 0 15px;
			font-size: 16px;
			color: #475569;
			.el-link {
				font-size: 16px;
				i {
					color: #155dfc;
				}
			}
			.el-link:after {
				content: '';
				padding-left: 20px;
				border-right: 1px solid #eaeaea;
			}
			.el-link:last-child::after {
				border-right: 1px solid transparent;
			}
		}
	}
	.el-link {
		display: inline-block;
		margin-left: 0;
		padding-right: 20px;
		color: #475569;
		i {
			color: #ec2b2d;
			font-style: normal;
		}
	}
	.el-link.el-link--primary {
		color: #155dfc;
	}
	.el-link:hover {
		color: #155dfc;
	}
	.el-link.is-underline:hover:after {
		border-bottom: none;
	}
	.sku {
		color: #94a3b8;
		font-size: 12px;
		margin: 0;
	}
	.address-box {
	}
	.order-tbl {
		width: 100%;
		border-collapse: collapse;
		.number-col {
			width: 55%;
		}
		.amount-col {
			width: 10%;
		}
		.amount-col {
			width: 10%;
		}
		.operate-col {
			width: 15%;
		}
		.tbl-head {
			height: 40px;
			color: #475569;
			font-size: 14px;
			background-color: rgba(227, 238, 255, 0.5);
			th {
				font-weight: 400;
			}
		}
		.tbl-body {
			td {
				padding: 0 15px;
				border: 1px solid #d0e3f9;
			}
			.sep-row {
				height: 20px;
				td {
					border: 0;
				}
			}
			.tr-th {
				height: 40px;
				font-size: 14px;
				line-height: 40px;
				color: #888;
				background-color: #e3eeff;
				span {
					margin-right: 20px;
				}
				.el-link {
					padding-right: 0;
					font-size: 14px;
					//color: #333333;
					color: #ef4444;
				}
				.right {
					float: right;
					margin-right: 0;
				}
			}
			.tr-bd {
				td {
					padding: 15px;
				}
				.goods-item {
					flex: 1;
					// float: left;
					// width: 80%;
					// margin-right: 40px;
				}
				.g-atcs {
					margin-top: 12px;
				}
				.g-title {
					margin-bottom: 8px;
				}

				.g-item-standard {
					cursor: pointer;
					transition: color 0.2s;
					color: inherit;
					text-decoration: none;

					&:hover {
						color: #155dfc;
					}

					&:active {
						color: #155dfc;
					}
				}

				.g-stitle {
					margin-bottom: 20px;
					font-size: 12px;
					color: #888888;
				}
				.number {
					margin-right: 30px;
				}
				em {
					font-weight: bold;
					font-style: normal;
				}
				.ftx-13 {
					font-size: 12px;
					color: #888888;
					border-top: 1px solid #888888;
					padding-top: 5px;
					display: inline-block;
				}
			}
		}
	}

	.logistics-info {
		p {
			font-size: 12px;
			color: #888888;
		}
		.logistics-name {
			margin-bottom: 2px;
			border-bottom: 1px dashed #e2e8f0;
			display: inline-block;
			padding-bottom: 3px;
		}
		.logistics-no {
			margin-top: 0px;
		}
	}

	//媒体查询-pad
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.orderwrap {
			width: 720px;
		}
		.topbox {
			.tabtit {
				.el-link {
					padding-right: 15px;
					font-size: 14px;
				}
			}
		}
		/deep/ .el-pagination {
			> span {
				display: none;
			}
		}
	}

	/deep/ .el-dropdown-menu__item.is-active {
		color: #155dfc;
		background-color: #ecf5ff;
	}

	.el-dropdown {
		margin-left: 0;
		padding-right: 20px;
	}

	.card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 24px;
		padding-bottom: 20px;
		border-bottom: 1px dashed #e2e8f0;
	}
	.card-title {
		font-size: 18px;
		font-weight: 700;
		color: #0f172a;
		margin-bottom: 4px;
	}
	.card-desc {
		font-size: 13px;
		color: #94a3b8;
		line-height: 1.6;
	}
</style>
